// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3qgai","title":"AfterFrontImage_title__2MBl2"};